import axios from 'axios';
import { getAuth } from 'firebase/auth';
import config from 'config';

const apiUrl = config.apiUrl;

// Helper function to convert File to base64
const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      // Remove the data URL prefix (e.g., "data:image/png;base64,")
      const base64String = reader.result.split(',')[1];
      resolve({
        name: file.name,
        type: file.type,
        data: base64String
      });
    };
    reader.onerror = (error) => reject(error);
  });
};

export const sendSupportRequest = async (data) => {
  const auth = getAuth();

  return new Promise((resolve, reject) => {
    auth.onAuthStateChanged(async (user) => {
      if (user) {
        try {
          const token = await user.getIdToken();
          const formData = new FormData();
          formData.append('subject', data.subject);
          formData.append('body', data.body);
          formData.append('user_id', user.uid);
          formData.append('user_email', user.email);

          if (data.attachments && data.attachments.length > 0) {
            for (let i = 0; i < data.attachments.length; i++) {
              const file = data.attachments[i];
              const base64Data = await fileToBase64(file);
              formData.append('attachments', JSON.stringify(base64Data));
            }
          }

          const response = await axios.post(`${apiUrl}/pro_plans/support/send`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: `Bearer ${token}`
            }
          });

          console.log('Support request sent successfully:', response.data);
          resolve(response.data);
        } catch (error) {
          console.error('Error sending support request:', error);
          if (error.response) {
            console.error('Response error data:', error.response.data);
            console.error('Response error status:', error.response.status);
          }
          reject(error);
        }
      } else {
        const error = new Error('No authenticated user found');
        console.error(error);
        reject(error);
      }
    });
  });
};
